import { Phone, Mail, Building2 } from "lucide-react";
import { Eyebrow, FadeUp } from "@/components/site/Reveal";
import { CONTACT } from "@/data/content";
import PatientEnquiry from "@/components/home/PatientEnquiry";

const ICONS = { patients: Phone, hospitals: Building2, email: Mail };
const ITEMS = CONTACT.map((c) => ({ ...c, icon: ICONS[c.id] }));

export default function Contact() {
  return (
    <section id="contact" className="relative py-24 sm:py-32 bg-[#FAFAFC]" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="relative overflow-hidden rounded-[36px] bg-brand-gradient p-8 sm:p-14 text-white grain">
          <div aria-hidden className="absolute -right-24 -bottom-24 h-80 w-80 rounded-full bg-[#14083E]/30 blur-3xl" />
          <div className="relative grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5">
            <FadeUp>
              <Eyebrow dark><span className="text-white">Speak to an advisor</span></Eyebrow>
              <h2 className="mt-5 font-display font-extrabold tracking-[-0.03em] leading-[0.98] text-4xl sm:text-5xl lg:text-6xl">
                Need a hospital, a test or a claim sorted?
              </h2>
              <p className="mt-5 text-white/90 max-w-md leading-relaxed">Fill in the request form or reach our care desk directly, and we will take it from there.</p>
            </FadeUp>
            <div className="mt-8 grid gap-3">
              {ITEMS.map((it, i) => {
                const Icon = it.icon;
                return (
                  <FadeUp key={it.id} delay={i * 0.08}>
                    <a href={it.href} data-testid={`contact-${it.id}`} className="flex items-center gap-4 rounded-2xl bg-white/15 backdrop-blur-md border border-white/25 p-4 hover:bg-white/25 transition-colors">
                      <span className="h-12 w-12 rounded-xl bg-white text-[#E5157A] grid place-items-center shrink-0"><Icon className="w-5 h-5" /></span>
                      <div>
                        <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-white/85">{it.label}</p>
                        <p className="font-display text-lg sm:text-xl font-semibold">{it.value}</p>
                      </div>
                    </a>
                  </FadeUp>
                );
              })}
            </div>
            </div>
            <FadeUp delay={0.1} className="lg:col-span-7">
              <div className="rounded-[28px] bg-white p-6 sm:p-8 text-[#14083E] shadow-[0_30px_60px_-30px_rgba(20,8,62,0.6)]" id="request-care">
                <h3 className="font-display text-2xl sm:text-3xl font-bold">Request care</h3>
                <p className="mt-1 mb-6 text-sm text-slate-600">Admissions, claims, check-ups and more — tell us what you need.</p>
                <PatientEnquiry />
              </div>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
